import { selectWidgetInstanceState } from '../selectors';
import { RpcStreamingWidgetState } from './WidgetRpcStreamState';
import State from 'store/State';
import { WidgetType } from 'widgets/WidgetType';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyRpcStreamingWidgetState = RpcStreamingWidgetState<any>;

export const selectRpcStreamingWidgetStreamState = <T>(
    state: State,
    widgetType: WidgetType,
    widgetKey: string
): T | undefined => {
    const widgetState = selectWidgetInstanceState(state, widgetType, widgetKey);
    return widgetState && (widgetState as AnyRpcStreamingWidgetState).stream;
};
